export default function iframeSandboxDomainStrategy(metaSiteId?: string): {
  iframeSandboxDomain?: string;
} {
  const iframeSandboxDomainParams: { iframeSandboxDomain?: string } = {};
  if (metaSiteId) {
    const host = 'filesusr';
    iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
  }
  return iframeSandboxDomainParams;
}
